// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yellow_btn_1 {
    /* background-color: var(--primary-yellow) !important; */
    background-color: #60A052 !important;
    /* color: var(--primary-grey) !important; */
    color: white !important;
    font-weight: 600 !important;
    padding: 0 !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 14px !important;
    height: 33px !important;
     display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-transform: unset !important;
}

.yellow_btn_1 i {
    font-size: 14px !important;
}
.clr_btn {
    background-color: #292b2c !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 0;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 14px;
    height: 33px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-transform: unset !important;
  }
  .srchbllue_1 {
    color: white !important;
    font-weight: 600 !important;
    padding: 0t;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 14px;
    height: 33px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-transform: unset !important;
  }
  .clr_btn_1 {
    height: 37px !important;
    border-radius: 6px !important;
  }

.table-container {
    width: 100%;
    overflow-x: auto;
}

.table-wrapper {
    min-width: 600px;
    /* Adjust as needed based on your table's minimum width */
}
.controls-container {
    display: flex;
    align-items: center;
    gap: var(--spacing-xl);
    margin-bottom: var(--spacing-lg);
    padding: var(--spacing-md) var(--spacing-xl);
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: var(--shadow-sm);
  }
  .tab_fuel thead tr {
    text-align: center !important;
  }
  .tab_fuel tbody tr {
    text-align: center !important;
  }


.attachment-text {
  display: inline-block;
  max-width: 200px; /* or whatever width suits your layout */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
@media(max-width: 768px) {
    .yellow_btn_1 {
        margin-left: 7px !important;
    }

    .date_div {
        width: 100% !important;
    }

    .table-wrapper {
        min-width: 100%;
    }
    .rel_comp {
        width: 100%  !important;
    }
    .tb_colored {
        display: flex !important;
        justify-content: center !important;
        margin-top: 10px !important;
    }
    .yellow_apply {
        display: flex;
        justify-content: center;
    }
    .yellow_apply .yellow_btn_1 {
        width: 30%;
    }

     .yellow_apply  .yellow_btn_2{
       width:30%
     }
}`, "",{"version":3,"sources":["webpack://./src/pages/FuelManagement/TrackFuel/TrackFuel.css"],"names":[],"mappings":"AAAA;IACI,wDAAwD;IACxD,oCAAoC;IACpC,2CAA2C;IAC3C,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;KACtB,wBAAwB;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;AAEF;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yDAAyD;AAC7D;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,4CAA4C;IAC5C,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;;;AAGF;EACE,qBAAqB;EACrB,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;QACxB,kCAAkC;QAClC,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,UAAU;IACd;;KAEC;OACE;KACF;AACL","sourcesContent":[".yellow_btn_1 {\r\n    /* background-color: var(--primary-yellow) !important; */\r\n    background-color: #60A052 !important;\r\n    /* color: var(--primary-grey) !important; */\r\n    color: white !important;\r\n    font-weight: 600 !important;\r\n    padding: 0 !important;\r\n    padding-left: 5px !important;\r\n    padding-right: 5px !important;\r\n    font-size: 14px !important;\r\n    height: 33px !important;\r\n     display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  text-transform: unset !important;\r\n}\r\n\r\n.yellow_btn_1 i {\r\n    font-size: 14px !important;\r\n}\r\n.clr_btn {\r\n    background-color: #292b2c !important;\r\n    color: white !important;\r\n    font-weight: 600 !important;\r\n    padding: 0;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    font-size: 14px;\r\n    height: 33px !important;\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    text-transform: unset !important;\r\n  }\r\n  .srchbllue_1 {\r\n    color: white !important;\r\n    font-weight: 600 !important;\r\n    padding: 0t;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    font-size: 14px;\r\n    height: 33px !important;\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    text-transform: unset !important;\r\n  }\r\n  .clr_btn_1 {\r\n    height: 37px !important;\r\n    border-radius: 6px !important;\r\n  }\r\n\r\n.table-container {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n}\r\n\r\n.table-wrapper {\r\n    min-width: 600px;\r\n    /* Adjust as needed based on your table's minimum width */\r\n}\r\n.controls-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-xl);\r\n    margin-bottom: var(--spacing-lg);\r\n    padding: var(--spacing-md) var(--spacing-xl);\r\n    background-color: var(--white);\r\n    border-radius: 4px;\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n  .tab_fuel thead tr {\r\n    text-align: center !important;\r\n  }\r\n  .tab_fuel tbody tr {\r\n    text-align: center !important;\r\n  }\r\n\r\n\r\n.attachment-text {\r\n  display: inline-block;\r\n  max-width: 200px; /* or whatever width suits your layout */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: bottom;\r\n}\r\n@media(max-width: 768px) {\r\n    .yellow_btn_1 {\r\n        margin-left: 7px !important;\r\n    }\r\n\r\n    .date_div {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .table-wrapper {\r\n        min-width: 100%;\r\n    }\r\n    .rel_comp {\r\n        width: 100%  !important;\r\n    }\r\n    .tb_colored {\r\n        display: flex !important;\r\n        justify-content: center !important;\r\n        margin-top: 10px !important;\r\n    }\r\n    .yellow_apply {\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .yellow_apply .yellow_btn_1 {\r\n        width: 30%;\r\n    }\r\n\r\n     .yellow_apply  .yellow_btn_2{\r\n       width:30%\r\n     }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
